export default {
  nav: {
    home: '首页',
    technology: '技术中心',
    products: '产品中心',
    quality: '品质保证',
    sales: '销售网络',
    customers: '客户案例',
    about: '关于我们',
    contact: '联系我们'
  },
  home: {
    hero: {
      title: '寻找机械零件供应商？',
      subtitle: '深耕自动化行业十余年，立足中国，面向全球。',
      btnDetails: '了解详情',
      btnAbout: '关于我们'
    },
    products: {
      actuators: '气动执行器',
      controllers: '气动控制器',
      accessories: '气动配件',
      emotion: 'E-Motion系列产品',
      machineParts: '机器零件',
      solutions: '定制化解决方案'
    },
    contact: {
      title: '联系我们',
      getStarted: '立即联系'
    }
  },
  products: {
    title: '产品中心',
    subtitle: '高品质产品，满足多样化需求',
    categories: {
      all: '全部产品',
      actuators: '气动执行器',
      accessories: '气动配件',
      controllers: '气动控制器',
      parts: '机器零件'
    },
    items: {
      actuator: {
        name: '气动执行器'
      },
      controller: {
        name: '气动控制器'
      },
      accessories: {
        name: '气动配件'
      },
      solutions: {
        name: '定制化解决方案'
      },
      emotion: {
        name: 'E-Motion系列产品'
      },
      machineParts: {
        name: '机器零件'
      }
    }
  },
  contact: {
    title: '联系方式',
    breadcrumb: {
      industrialParts: 'Gyre工业机械零件',
      actuators: '气动执行器',
      controllers: '气动控制器',
      solutions: '定制化解决方案',
      current: '联系方式'
    },
    heading: '联系我们',
    email: 'hemu@gyansol.com',
    whatsapp: '+86 13357553736',
    tel: '电话：',
    phone: '+8619290808990',
    promise: '我们承诺在每个工作日提供高效的响应服务。'
  },
  footer: {
    description: '领先的气动元件品牌',
    links: {
      products: '产品中心',
      solutions: '解决方案',
      about: '关于我们'
    },
    copyright: '© 2025 GYRE CMS. 版权所有.'
  },
  common: {
    loading: '加载中...',
    noData: '暂无数据',
    error: '操作失败',
    retry: '重试',
    save: '保存',
    cancel: '取消',
    confirm: '确认'
  },
  notFound: {
    title: '404',
    subtitle: '页面未找到',
    description: '您访问的页面不存在。',
    backHome: '返回首页'
  },
  technology: {
    hero: {
      title: '技术创新',
      subtitle: '引领行业技术发展，提供卓越解决方案'
    },
    items: {
      smartManufacturing: {
        title: '智能制造',
        description: '采用先进的智能制造技术，提高生产效率和产品质量，实现生产过程的数字化和自动化。'
      },
      precisionControl: {
        title: '精密控制',
        description: '高精度控制系统确保产品的一致性和可靠性，满足最严格的质量标准要求。'
      },
      energySaving: {
        title: '节能环保',
        description: '绿色制造技术，降低能耗和排放，实现可持续发展目标。'
      },
      digitalTransformation: {
        title: '数字化转型',
        description: '全面的数字化解决方案，提升企业运营效率和市场竞争力。'
      }
    }
  },
  about: {
    hero: {
      title: '关于我们'
    },
    breadcrumb: {
      industrialParts: 'Gyre工业机械零件',
      actuators: '气动执行器',
      controllers: '气动控制器',
      solutions: '定制化解决方案',
      current: '关于我们'
    },
    intro: {
      text: '我们是一家专注于气动、流体、电驱动和自动化设计的系统集成商，为非标自动化、半导体和医疗器械等高端行业提供定制化工程解决方案。公司总部位于昆山和宁波，两个精密制造基地专门生产和定制产品——低摩擦气缸、精密气体调节器、医疗级配件和管道、紧凑型歧管阀和定制气动柜。'
    },
    welcome: {
      title: '欢迎',
      contact: '如何联系我们？',
      email: 'hemu@gyansol.com',
      tel: '电话：',
      phone: '+8619290808990',
      promise: '我们承诺在每个工作日提供高效的响应服务。'
    }
  }
}
